export default __webpack_public_path__ + "avid-media-composer.efd6773a.png";